/* eslint-disable camelcase */
import React, { useState, useEffect } from "react";
import i18n from "i18n-react";

import { APIHandler, DataHandler, RegisterPage, StorageHandler } from "C4";
import { storageKeys } from "settings";

import { toast, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Zoom = cssTransition({
  enter: "zoomIn",
  exit: "zoomOut",
  duration: [500, 800],
});

const CustomToast = () => (
  <div>
    Thank you sincerely for your interest in TheSOURCE, and we equally
    appreciate your right to supreme privacy. This initial FREE version requires
    users to opt-in to communication from the sponsoring destinations and
    suppliers to unlock training and sales resources. If you would like to wait
    for the paid version next year,{" "}
    <a href="/premium" target="_blank">
      please tap here
    </a>
    , and we’ll let you know when it launches.
  </div>
);

let registerPages = [
  {
    title: "Create new account",
    accent: ".",
    intro: "Confirm Email and Create Password.",
    bubbles: false,
    options: [
      {
        id: "reg_type_of_user",
        name: "Registration Type",
        type: "select",
        required: true,
        options: [
          {
            id: "travel_advisor",
            name: "Travel Advisor",
          },
          {
            id: "industry_visitor",
            name: "Industry Visitor",
          },
        ],
      },
      {
        id: "reg_email",
        name: "Business Email",
        type: "email",
        required: true,
      },
      {
        id: "reg_password",
        name: "Password",
        type: "password",
        required: true,
      },
      {
        id: "reg_confirmPassword",
        name: "Confirm Password",
        type: "password",
        required: true,
      },
    ],
  },
  {
    title: "Describe your Business",
    accent: ".",
    intro: "What best describes you and your agency’s business?",
    id: "reg_agency_business",
    bubbles: true,
    options: [
      {
        id: "Retail Store Front",
        name: "Retail Store Front",
        color: "#F2A900",
        size: "medium",
      },
      {
        id: "Home-Based Agent",
        name: "Home-Based Agent",
        color: "#F36CC5",
        size: "medium",
      },
      {
        id: "Independent Contractor",
        name: "Independent Contractor",
        color: "#d18b65",
        size: "big",
      },
      {
        id: "Host Agency",
        name: "Host Agency",
        color: "#40c6d5",
        size: "medium",
      },
      {
        id: "Call Center or Web-Based Agency",
        name: "Call Center or Web-Based Agency",
        color: "#7a65d1",
        size: "small",
      },
      {
        id: "Not Applicable",
        name: "Not Applicable",
        color: "#c51818",
        size: "small",
      },
      {
        id: "Other",
        name: "Other",
        color: "#65D17D",
        size: "small",
      },
    ],
  },
  {
    title: "Describe Your Business and Specialization",
    accent: ".",
    intro: "",
    bubbles: false,
    options: [
      {
        id: "reg_agency_name",
        name: "Agency Name",
        type: "text",
        required: true,
      },
      {
        id: "reg_agency_affiliation",
        name: "Your primary Association affiliation?",
        type: "select",
        required: true,
        options: [
          {
            id: "AAA",
            name: "AAA",
          },
          {
            id: "Affluent Traveler Collection",
            name: "Affluent Traveler Collection",
          },
          {
            id: "American Express",
            name: "American Express",
          },
          {
            id: "Avoya Travel",
            name: "Avoya Travel",
          },
          {
            id: "CAA",
            name: "CAA",
          },
          {
            id: "Carlson Wagonlit Travel",
            name: "Carlson Wagonlit Travel",
          },
          {
            id: "CCRA",
            name: "CCRA",
          },
          {
            id: "Cruise Planners",
            name: "Cruise Planners",
          },
          {
            id: "Ensemble Travel",
            name: "Ensemble Travel",
          },
          {
            id: "Expedia Group",
            name: "Expedia Group",
          },
          {
            id: "GSM",
            name: "GSM",
          },
          {
            id: "Leisure Travel Alliance",
            name: "Leisure Travel Alliance",
          },
          {
            id: "Liberty Travel",
            name: "Liberty Travel",
          },
          {
            id: "MAST",
            name: "MAST",
          },
          {
            id: "Nest",
            name: "Nest",
          },
          {
            id: "OASIS Travel Network",
            name: "OASIS Travel Network",
          },
          {
            id: "RADIUS",
            name: "RADIUS",
          },
          {
            id: "Rovia",
            name: "Rovia",
          },
          {
            id: "Signature",
            name: "Signature",
          },
          {
            id: "THOR",
            name: "THOR",
          },
          {
            id: "Travel Leaders Network",
            name: "Travel Leaders Network",
          },
          {
            id: "Travel Planners International",
            name: "Travel Planners International",
          },
          {
            id: "TRAVELSAVERS",
            name: "TRAVELSAVERS",
          },
          {
            id: "Uniglobe",
            name: "Uniglobe",
          },
          {
            id: "Virtuoso",
            name: "Virtuoso",
          },
          {
            id: "WESTA",
            name: "WESTA",
          },
          {
            id: "World Travel Holdings",
            name: "World Travel Holdings",
          },
          {
            id: "None",
            name: "None",
          },
          {
            id: "OTHER",
            name: "OTHER",
          },
        ],
      },
      {
        id: "reg_id_type",
        name: "What Association  I.D. # do you typically use? ",
        type: "select",
        required: true,
        options: [
          {
            id: "ARC/IATA",
            name: "ARC/IATA",
          },
          {
            id: "CLIA",
            name: "CLIA",
          },
          {
            id: "TRUE",
            name: "TRUE",
          },
          {
            id: "Other",
            name: "Other",
          },
        ],
      },
      {
        id: "reg_id_number",
        name: "Please enter I.D. number",
        type: "text",
      },
      {
        id: "reg_annual_sales",
        name: "What are YOUR annual travel sales?",
        type: "select",
        required: true,
        options: [
          {
            id: "< $250k",
            name: "< $250k",
          },
          {
            id: "$250k - $1mm",
            name: "$250k - $1mm",
          },
          {
            id: "$1mm - $2mm",
            name: "$1mm - $2mm",
          },
          {
            id: "$2mm or higher",
            name: "$2mm or higher",
          },
        ],
      },
    ],
  },
  {
    title:
      "Please tap three bubbles that best represent your geo specialization",
    accent: ".",
    intro: "Yes, you can press the bubbles :)",
    id: "reg_destination",
    bubbles: true,
    multiple: true,
    options: [
      {
        id: "South America",
        name: "South America",
        color: "#F36CC5",
        size: "small",
      },
      {
        id: "Mexico",
        name: "Mexico",
        color: "#774A29",
        size: "small",
      },
      {
        id: "Asia",
        name: "Asia",
        color: "#2C8746",
        size: "small",
      },
      {
        id: "Caribbean",
        name: "Caribbean",
        color: "#FA0808",
        size: "medium",
      },
      {
        id: "Europe",
        name: "Europe",
        color: "#964E56",
        size: "medium",
      },
      {
        id: "USA/Canada",
        name: "USA/Canada",
        color: "#F26634",
        size: "big",
      },
      {
        id: "Africa/Middle East",
        name: "Africa/Middle East",
        color: "#F2A900",
        size: "small",
      },
      {
        id: "Australia/New Zealand/South Pacific",
        name: "Australia/New Zealand/South Pacific",
        color: "#65D17D",
        size: "small",
      },
    ],
  },
  {
    title:
      "Please tap three bubbles that best represent your niche specialization",
    accent: ".",
    intro: "",
    id: "reg_travel_type",
    bubbles: true,
    multiple: true,
    options: [
      {
        id: "Adventure/ Expedition",
        name: "Adventure/ Expedition",
        color: "#B89379",
        size: "big",
      },
      {
        id: "All Inclusive",
        name: "All Inclusive",
        color: "#65D17D",
        size: "medium",
      },
      {
        id: "Business/ MICE",
        name: "Business/ MICE",
        color: "#A74297",
        size: "small",
      },
      {
        id: "Culture/ Experiential",
        name: "Culture/ Experiential",
        color: "#009ABF",
        size: "medium",
      },
      {
        id: "Cruise",
        name: "Cruise",
        color: "#2C8746",
        size: "small",
      },
      {
        id: "Family/ Multi Generational",
        name: "Family/ Multi Generational",
        color: "#CA2438",
        size: "medium",
      },
      {
        id: "Romance/ Weddinng/ Honeymoon",
        name: "Romance/ Weddinng/ Honeymoon",
        color: "#FC92D8",
        size: "big",
      },
      {
        id: "Luxury",
        name: "Luxury",
        color: "#F2A900",
        size: "medium",
      },
      {
        id: "Rail",
        name: "Rail",
        color: "#214BE0",
        size: "small",
      },
      {
        id: "Tours",
        name: "Tours",
        color: "#964E56",
        size: "medium",
      },
      {
        id: "Wellness/ Health/ Spa",
        name: "Wellness/ Health/ Spa",
        color: "#466488",
        size: "medium",
      },
    ],
  },
  {
    title: "One more step",
    accent: ".",
    intro:
      "You’re almost done! Fill in these last items to complete your registration.",
    bubbles: false,
    options: [
      {
        id: "reg_first_name",
        name: "First Name (Given)",
        type: "text",
        required: true,
      },
      {
        id: "reg_last_name",
        name: "Last Name (Family)",
        type: "text",
        required: true,
      },
      {
        id: "reg_zip_code",
        name: "ZipCode/Postal Code",
        type: "text",
        required: true,
      },
      {
        id: "reg_city",
        name: "City",
        type: "text",
        required: true,
      },
    ],
  },
];

const registerPagesIndustry = [
  {
    title: "Create new account",
    accent: ".",
    intro: "Confirm Email and Create Password.",
    bubbles: false,
    options: [
      {
        id: "reg_type_of_user",
        name: "Registration Type",
        type: "select",
        required: true,
        options: [
          {
            id: "travel_advisor",
            name: "Travel Advisor",
          },
          {
            id: "industry_visitor",
            name: "Industry Visitor",
          },
        ],
      },
      {
        id: "reg_email",
        name: "Business Email",
        type: "email",
        required: true,
      },
      {
        id: "reg_password",
        name: "Password",
        type: "password",
        required: true,
      },
      {
        id: "reg_confirmPassword",
        name: "Confirm Password",
        type: "password",
        required: true,
      },
    ],
  },
  {
    title: "Describe Your Business and Specialization",
    accent: ".",
    intro: "",
    bubbles: false,
    options: [
      {
        id: "reg_agency_name",
        name: "Business Name",
        type: "text",
        required: true,
      },
      {
        id: "reg_agency_business",
        name: "What best describes your company’s business?",
        type: "select",
        required: true,
        options: [
          {
            id: "Accommodation",
            name: "Accommodation",
          },
          {
            id: "Association",
            name: "Association",
          },
          {
            id: "Attraction",
            name: "Attraction",
          },
          {
            id: "Aviation",
            name: "Aviation",
          },
          {
            id: "Cruise",
            name: "Cruise",
          },
          {
            id: "Destination Management Company",
            name: "Destination Management Company",
          },
          {
            id: "Government Agency",
            name: "Government Agency",
          },
          {
            id: "Ground Transportation",
            name: "Ground Transportation",
          },
          {
            id: "Insurance",
            name: "Insurance",
          },
          {
            id: "Media",
            name: "Media",
          },
          {
            id: "Non-Profit",
            name: "Non-Profit",
          },
          {
            id: "Other",
            name: "Other",
          },
          {
            id: "Technology",
            name: "Technology",
          },
          {
            id: "Tourism Board",
            name: "Tourism Board",
          },
          {
            id: "Tour Operator",
            name: "Tour Operator",
          },
        ],
      },
    ],
  },
  {
    title: "Please tap the bubble that best describes your job function",
    accent: ".",
    intro: "Yes, you can press the bubbles :)",
    id: "reg_custom_1",
    bubbles: true,
    multiple: false,
    options: [
      {
        id: "Sales",
        name: "Sales",
        color: "#F36CC5",
        size: "small",
      },
      {
        id: "Marketing",
        name: "Marketing",
        color: "#774A29",
        size: "small",
      },
      {
        id: "Media / PR",
        name: "Media / PR",
        color: "#009ABF",
        size: "medium",
      },
      {
        id: "Learning / Development",
        name: "Learning / Development",
        color: "#2C8746",
        size: "small",
      },
      {
        id: "Events",
        name: "Events",
        color: "#FA0808",
        size: "medium",
      },
      {
        id: "Other",
        name: "Other",
        color: "#964E56",
        size: "medium",
      },
    ],
  },
  {
    title: "Please tap the bubbles that best represent your business geo",
    accent: ".",
    intro: "",
    id: "reg_custom_2",
    bubbles: true,
    multiple: true,
    options: [
      {
        id: "South America",
        name: "South America",
        color: "#F36CC5",
        size: "small",
      },
      {
        id: "Mexico",
        name: "Mexico",
        color: "#774A29",
        size: "small",
      },
      {
        id: "Asia",
        name: "Asia",
        color: "#2C8746",
        size: "small",
      },
      {
        id: "Caribbean",
        name: "Caribbean",
        color: "#FA0808",
        size: "medium",
      },
      {
        id: "Europe",
        name: "Europe",
        color: "#964E56",
        size: "medium",
      },
      {
        id: "USA/Canada",
        name: "USA/Canada",
        color: "#F26634",
        size: "big",
      },
      {
        id: "Africa/Middle East",
        name: "Africa/Middle East",
        color: "#F2A900",
        size: "small",
      },
      {
        id: "Australia/New Zealand/South Pacific",
        name: "Australia/New Zealand/South Pacific",
        color: "#65D17D",
        size: "small",
      },
    ],
  },
  {
    title: "One more step",
    accent: ".",
    intro:
      "You’re almost done! Fill in these last items to complete your registration.",
    bubbles: false,
    options: [
      {
        id: "reg_first_name",
        name: "First Name (Given)",
        type: "text",
        required: true,
      },
      {
        id: "reg_last_name",
        name: "Last Name (Family)",
        type: "text",
        required: true,
      },
      {
        id: "reg_zip_code",
        name: "ZipCode/Postal Code",
        type: "text",
        required: true,
      },
      {
        id: "reg_city",
        name: "City",
        type: "text",
        required: true,
      },
    ],
  },
];

const Register = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const [country, setCountry] = useState("US");

  const [userInput, setUserInput] = useState({
    email: "",
    reg_email: "",
    reg_type_of_user: "",
    reg_password: "",
    reg_confirmPassword: "",
    reg_first_name: "",
    reg_last_name: "",
    reg_agency_affiliation: "",
    reg_agency_business: "",
    reg_destination: [],
    reg_travel_type: [],
    reg_agency_name: "",
    reg_annual_sales: "",
    reg_id_number: "",
    reg_id_type: "",
    reg_country: country,
    reg_zip_code: "",
    reg_city: "",
    reg_state: "",
    marketing_travel_brands: false,
    marketing_opt_in: false,
    reg_custom_1: [],
    reg_custom_2: [],
  });

  const setAddress = (array) => {
    // const obj = {
    //   reg_zipcode: array.postalCode,
    //   reg_country: array.country,
    //   reg_state: array.province,
    // };
    // Object.keys(obj).map((item, index) => {
    //   const input = userInput;
    //   input[item] = Object.values(obj)[index];
    //   setUserInput(input);
    // });
  };

  const checkPathname = async (callback) => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token !== null) {
      const user = await APIHandler.getUser(760, token);

      // Remove password
      delete registerPages[0]["options"][3];
      delete registerPages[0]["options"][2];

      // Change copy
      registerPages[0]["title"] = "Confirm your information";
      registerPages[0]["intro"] = "";
      registerPages = registerPages;

      callback((prev) => ({
        ...prev,
        email: user.email,
        reg_email: user.email,
        reg_type_of_user: "travel_advisor",
        reg_agency_name: user.agency_name,
        reg_agency_affiliation: user.agency_affiliation,
        reg_agency_business: user.agency_business,
        reg_first_name: user.first_name,
        reg_last_name: user.last_name,
        reg_annual_sales: user.annual_sales,
        reg_id_number: user.id_number,
        reg_id_type: user.id_type,
        reg_city: user.city,
        reg_country: user.country,
        reg_state: user.state,
        reg_zip_code: user.zip_code,
        reg_agency_affiliation: user.agency_affiliation,
      }));
    }
  };

  const emptyBubbleStorage = async () => {
    const registerBubbles = await StorageHandler.load(
      storageKeys.registerBubbles
    );
    //if (!registerBubbles) {
    const emptyBubbles = [
      { page: 1, bubble: "" },
      { page: 2, bubble: "" },
      { page: 3, bubble: [] },
      { page: 4, bubble: [] },
      { page: 5, bubble: "" },
    ];

    StorageHandler.save(storageKeys.registerBubbles, emptyBubbles);
    //}
  };

  useEffect(() => {
    checkPathname(setUserInput);
    emptyBubbleStorage();
  }, []);

  const changeHandler = (event) => {
    const input = userInput;
    input[event.target.id] = event.target.value;
    setUserInput(input);

    if (event.target.id === "reg_country") {
      setCountry(event.target.value);
    }
  };

  const handleBubbleClick = (id, bubble) => {
    const input = userInput;
    input[id] = bubble;
    setUserInput(input);
  };

  const checkInputValidity = () => {
    const inputs = document.getElementsByTagName("input");
    const inputArray = [];

    Array.from(inputs).forEach((input) => {
      inputArray.push(input);
    });

    return inputArray.every((val) => val.checkValidity() === true);
  };

  const checkInputValidityFields = () => {
    const inputs = document.getElementsByTagName("input");
    const inputArray = [];
    const selects = document.getElementsByTagName("select");
    const selectArray = Array.from(selects);

    Array.from(inputs).forEach((input) => {
      inputArray.push(input);
    });

    const emptyFields = [];
    inputs.forEach((input) => {
      if (input.checkValidity() === false) {
        const name = input.name.replace(/reg_/g, "").replace(/_/g, " ");
        emptyFields.push(name);
      }
    });

    selectArray.forEach((select) => {
      if (select.selectedIndex === 0) {
        const name = select.name.replace(/reg_/g, "").replace(/_/g, " ");
        emptyFields.push(name);
      }
    });

    return emptyFields;
  };

  const checkPassword = () => {
    const { reg_password, reg_confirmPassword } = userInput;
    return reg_password === reg_confirmPassword;
  };

  const checkPasswordLength = () => {
    const password = document.getElementById("reg_password").value;
    return password.length >= 8;
  };

  const registerHandler = () => {
    const { pathname } = window.location;
    const info = userInput;

    // TODO update object to match backend
    const registerObject = {
      first_name: info.reg_first_name,
      last_name: info.reg_last_name,
      agency_name: info.reg_agency_name,
      type_of_user: info.reg_type_of_user,
      state: info.reg_state,
      city: info.reg_city,
      zip_code: info.reg_zip_code,
      country: info.reg_country,
      id_type: info.reg_id_type,
      id_number: info.reg_id_number,
      agency_revenue: info.reg_annual_sales,
      agency_business: info.reg_agency_business,
      agency_affiliation: info.reg_agency_affiliation,
      travel_type_1: info.reg_travel_type[0] ? info.reg_travel_type[0] : "",
      travel_type_2: info.reg_travel_type[1] ? info.reg_travel_type[1] : "",
      travel_type_3: info.reg_travel_type[2] ? info.reg_travel_type[2] : "",
      destination_1: info.reg_destination[0] ? info.reg_destination[0] : "",
      destination_2: info.reg_destination[1] ? info.reg_destination[1] : "",
      destination_3: info.reg_destination[2] ? info.reg_destination[2] : "",
      marketing_travel_brands:
        info.marketing_travel_brands === "" ? true : false,
      marketing_opt_in: info.marketing_opt_in === "" ? true : false,
      custom_1: info.custom_1 ? info.custom_1 : "",
      custom_2: info.custom_2 ? info.custom_2 : "",
      custom_3: info.custom_3 ? info.custom_3 : "",
    };

    DataHandler.matchAppId().then((appId) => {
      APIHandler.setUser(info.reg_email, appId, registerObject).then(() => {
        APIHandler.getUserOld(appId, info.reg_email).then((newUser) => newUser);
        if (pathname === "/login/quick-register") {
          // Mobile register end call
          localStorage.setItem("registerSuccessful", true);
          window.setTimeout(() => {
            window.location.href = "https://www.thesource.travel/home/";
          }, 5000);
        }
      });
    });

    // if (pathname === '/login/register-mobile') {
    //   window.ReactNativeWebView.postMessage(`registered:${info.reg_email}`);
    // }
  };

  const registerHandlerSSO = async (event) => {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();

    const name = `${userInput.reg_first_name} ${userInput.reg_last_name}`;
    const email = userInput.reg_email;
    const company = userInput.reg_agency_name || "";
    const password = userInput.reg_password;
    const confirmPassword = userInput.reg_confirmPassword;

    APIHandler.registerSSOUser(
      name,
      email,
      company,
      password,
      confirmPassword
    ).then((SSOUser) => {
      if (window.location.pathname !== "/login/quick-register") {
        if (SSOUser.success === false) {
          toast.error(
            "This email address already exists or is invalid. Please try with another email address or login to your account.",
            {
              position: "top-center",
              transition: Zoom,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
          submit.disabled = false;
          return;
        }
      }

      // Old school register
      registerHandler();
      const { pathname } = window.location;

      toast.success(
        "Registration / Update Account Successful! You are now being redirected to the home page.",
        {
          position: "bottom-center",
          transition: Zoom,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      submit.disabled = false;

      APIHandler.registerUserProgress(email).then((registered) => {
        if (registered) {
          if (pathname.includes("/login/quick-register")) {
            // Mobile register end call
            window.setTimeout(() => {
              window.location.href = "https://www.thesource.travel/home/";
            }, 5000);
            return;
          } else {
            window.location.href =
              "https://www.thesource.travel/?state=login&registered=success";
          }

          if (pathname.includes("/login/register-mobile")) {
            // Mobile register end call
            localStorage.setItem("registerSuccessful", true);
            window.setTimeout(() => {
              window.postMessage("exit");
              window.ReactNativeWebView.postMessage("exit");
            }, 5000);
            return;
          }

          // window.setTimeout(() => {
          //   window.ReactNativeWebView.postMessage('login');
          // }, 5000);

          // window.setTimeout(() => {
          //   localStorage.setItem('registerSuccessful', true);
          //   window.location.href = '/';
          // }, 5000);
        }
      });
    });
  };

  const nextPage = (e) => {
    e.preventDefault();
    if (pageNumber === 0) {
      console.log(userInput.reg_type_of_user);
      if (
        userInput.reg_type_of_user !== "travel_advisor" &&
        userInput.reg_type_of_user !== "Travel Advisor"
      ) {
        registerPages = registerPagesIndustry;
      }

      if (window.location.pathname !== "/login/quick-register") {
        if (checkInputValidity()) {
          APIHandler.checkEmail(userInput.reg_email).then((res) => {
            if (res.success === true) {
              toast.error(
                i18n.translate(
                  "This email address already exists or is invalid. Please try with another email address or login to your account."
                ),
                {
                  position: "top-center",
                  transition: Zoom,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
              return;
            }

            if (!checkPassword()) {
              toast.error(
                i18n.translate("loginScreen.errors.passwordNotMatching"),
                {
                  position: "top-center",
                  transition: Zoom,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
              return;
            }

            if (!checkPasswordLength()) {
              toast.error(
                i18n.translate("loginScreen.errors.passwordTooShort"),
                {
                  position: "top-center",
                  transition: Zoom,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
              return;
            }

            setPageNumber(pageNumber + 1);
          });
        } else {
          toast.error(
            "Please make sure you have filled in a valid email address and password (at least 8 characters).",
            {
              position: "top-center",
              transition: Zoom,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
          return;
        }
        return;
      }
    }

    // Valid continue path
    if (checkInputValidity()) {
      if (
        userInput.reg_type_of_user !== "travel_advisor" &&
        userInput.reg_type_of_user !== "Travel Advisor"
      ) {
        if (pageNumber === 4) {
          // Show popup for free if not selecting custom_1 + custom_2
          // Removed for industry visitors, not visible + not required
          // if ((userInput.marketing_travel_brands === false) || (userInput.marketing_opt_in === false)) {
          //   toast.warning(CustomToast, {
          //     position: 'bottom-center',
          //     transition: Zoom,
          //     hideProgressBar: true,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     autoClose: 65000,
          //   });
          //   return;
          // }

          registerHandlerSSO(e);
          return;
        }
      }

      if (pageNumber === 5) {
        // Show popup for free if not selecting custom_1 + custom_2
        if (
          userInput.marketing_travel_brands === false ||
          userInput.marketing_opt_in === false
        ) {
          toast.warning(CustomToast, {
            position: "bottom-center",
            transition: Zoom,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            autoClose: 65000,
          });
          return;
        }

        registerHandlerSSO(e);
        return;
      }

      setPageNumber(pageNumber + 1);
      return;
    }

    const invalidFields = `Please fill in all the required fields: ${checkInputValidityFields().join(
      ", "
    )}`;
    toast.error(invalidFields, {
      position: "top-center",
      transition: Zoom,
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  const prevPage = (e) => {
    e.preventDefault();
    setPageNumber(pageNumber - 1);
  };

  console.log(country);

  return (
    <div className="Register">
      {registerPages.map((item, index) => {
        if (index === pageNumber) {
          return (
            <RegisterPage
              items={item}
              pageNumber={pageNumber}
              nextPage={nextPage}
              prevPage={prevPage}
              change={changeHandler}
              handleBubbleClick={handleBubbleClick}
              userInput={userInput}
              setAddress={setAddress}
              country={country}
            />
          );
        }
        return null;
      })}
    </div>
  );
};

export default Register;
